import * as utils from '@utils';
import { Fragment } from 'react';
import type { Audience } from 'types/schema';
import Styled from './AudienceTooltip.styled';

interface Props {
  audience: Audience & { base?: string | null };
  color?: string;
}

function AudienceTooltip({ audience, color }: Props) {
  const { icon, description } = utils.getAudienceMetadata(audience.type);

  return (
    <Styled.Wrapper>
      <Styled.Title color={color}>{audience.title}</Styled.Title>
      {audience.description && (
        <Styled.Description className="static-scrollbar">
          {audience.description}
        </Styled.Description>
      )}
      <Styled.Meta>
        {Object.entries({
          sample: {
            label: 'Sample size',
            value: audience.sample
              ? `${(audience.sample / 1000).toFixed(1)}k`
              : null
          },
          universe: {
            label: 'Universe',
            value: audience.universe
              ? utils.formatLargeNumber(audience.universe)
              : null
          },
          percentage: {
            label: 'Datapoint %',
            value: audience.percentage
              ? `${audience.percentage.toFixed(1)}%`
              : null
          },
          datasets: {
            label: 'Dataset',
            value:
              audience.datasets?.length > 0
                ? audience.datasets.join(', ')
                : null
          },
          type: {
            label: 'Type',
            value: audience.type ? (
              <Fragment>
                <Styled.AudienceIcon>{icon}</Styled.AudienceIcon>{' '}
                <Styled.AudienceDescription>
                  {description}
                </Styled.AudienceDescription>
              </Fragment>
            ) : null
          }
        }).map(
          ([key, { label, value }]) =>
            value && (
              <Fragment key={`tooltip-metadata-${audience.id}-${key}`}>
                <Styled.MetaLabel>{label}</Styled.MetaLabel>
                <Styled.MetaValue>{value}</Styled.MetaValue>
              </Fragment>
            )
        )}
      </Styled.Meta>
    </Styled.Wrapper>
  );
}

export default AudienceTooltip;
